import { createApi } from "@reduxjs/toolkit/query/react";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import {baseQueryWithReauth} from "./config";
import helper from "../../constants/helper";

export const ApiTags = {
  VIDEOS: "Videos",
  VIDEO: "Video",
  USER: "User",
  PROFILES: "PROFILES",
  PROFILE: "PROFILE",
} as const;

export const ApiTagsList = Object.values(ApiTags);

export const createBaseApi = (reducerPath: string) => createApi({
  reducerPath,
  baseQuery: baseQueryWithReauth,
  tagTypes: ApiTagsList,
  keepUnusedDataFor: 180,
  endpoints: () => ({})
});

export const getErrorMessage = (error: FetchBaseQueryError | SerializedError) => {
  if ("status" in error) {
    // This is a FetchBaseQueryError
    const fetchError = error as FetchBaseQueryError | any;
    return fetchError.data?.message || "Error";
  }
  // This is a SerializedError
  return error.message || "An error occurred...";
};


